import { LastMessageSystem } from '@halo/ui-chat-react';
import { MsgUnknownContent, type MsgUnknownContentProps } from './msg-unknown-content';

export interface MsgUnknownPreviewProps extends MsgUnknownContentProps {}

export const MsgUnknownPreview = memo(function MsgUnknownPreview({
  message,
}: MsgUnknownPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgUnknownContent message={message} />
    </LastMessageSystem>
  );
});
